<template>
  <a-form-model
      ref="targetForm"
      :model="form"
      :rules="rules"
      :label-col="{span: 12}"
      :wrapper-col="{span: 12}"
  >
    <a-alert message="温馨提示：请注意您填写的信息仅适用于签证申请，请如实提供真实信息。" banner closable/>
    <a-card title="个人信息">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有曾有名" prop="otherName">
            <a-radio-group v-model="form.otherName">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="姓氏(曾有名)" prop="otherSurname">
            <a-input placeholder="例如 li" v-model="form.otherSurname"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.otherName === 'Yes'">
          <a-form-model-item label="名字(曾有名)" prop="otherGivenName">
            <a-input placeholder="例如 xinan" v-model="form.otherGivenName"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-model="form.sex">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否有身份证" prop="hasNationalIdentification">
            <a-radio-group v-model="form.hasNationalIdentification">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <template v-if="form.hasNationalIdentification && form.hasNationalIdentification === 'Yes'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="身份证号" prop="nationalIdentification">
              <a-input placeholder="" v-model="form.nationalIdentification"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="身份证有效期" prop="startDateForIdCardNo">
              <a-date-picker style="width: 100%" v-model="form.startDateForIdCardNo" placeholder="开始"
                             value-format="YYYY-MM-DD" :disabled-date="afterNow"/>

            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="身份证有效期" prop="endDateForIdCardNo">
              <a-date-picker style="width: 100%" v-model="form.endDateForIdCardNo" placeholder="结束(长期可不填)"
                             value-format="YYYY-MM-DD" :disabled-date="beforeNow"/>
            </a-form-model-item>
          </a-col>

          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="身份证签发地" prop="placeOfIdentification">
              <a-input placeholder="例如 广东" v-model="form.placeOfIdentification"/>
            </a-form-model-item>
          </a-col>
        </template>
        <template v-if="form.hasNationalIdentification && form.hasNationalIdentification === 'No'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="原因" prop="nationalIdentificationReason">
              <a-input placeholder="例如 未成年" v-model="form.nationalIdentificationReason"/>
            </a-form-model-item>
          </a-col>
        </template>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照有效期" prop="startDateForPassport">
            <a-date-picker style="width: 100%" v-model="form.startDateForPassport" placeholder="开始"
                           value-format="YYYY-MM-DD" :disabled-date="afterNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照有效期" prop="endDateForPassport">
            <a-date-picker style="width: 100%" v-model="form.endDateForPassport" placeholder="结束"
                           value-format="YYYY-MM-DD" :disabled-date="beforeNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="护照签发地" prop="placeOfPassport">
            <a-input placeholder="例如 广东" v-model="form.placeOfPassport"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生省份" prop="provinceOfBirth">
            <a-select placeholder="请选择" v-model="form.provinceOfBirth">
              <a-select-option v-for="item in provinceList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="出生城市" prop="cityOfBirth">
            <a-input placeholder="例如 广州" v-model="form.cityOfBirth"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="婚姻状况" prop="maritalStatus">
            <a-select v-model="form.maritalStatus" placeholder="请选择">
              <a-select-option value="M">已婚</a-select-option>
              <a-select-option value="N">单身</a-select-option>
              <a-select-option value="W">丧偶</a-select-option>
              <a-select-option value="D">离异</a-select-option>
              <a-select-option value="S">合法分居</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="联系信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址省份" prop="homeAddressForProvince">
            <a-select placeholder="请选择" v-model="form.homeAddressForProvince">
              <a-select-option v-for="item in provinceList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址城市" prop="homeAddressForCity">
            <a-input placeholder="例如 广州" v-model="form.homeAddressForCity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址" prop="homeAddressForStreet">
            <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.homeAddressForStreet"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭地址邮编" prop="homeAddressForZipCode">
            <a-input placeholder="例如 00000" v-model="form.homeAddressForZipCode"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="手机号" prop="primaryPhoneNumber">
            <a-input placeholder="例如 13900000000" v-model="form.primaryPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家庭电话" prop="secondaryPhoneNumber">
            <a-input placeholder="例如 07565573638" v-model="form.secondaryPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="工作电话" prop="workPhoneNumber">
            <a-input placeholder="例如 07565573638" v-model="form.workPhoneNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="现用电子邮箱" prop="emailAddress">
            <a-input placeholder="例如 xxx@gmail.com" v-model="form.emailAddress"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="家庭信息(非入境)" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人姓1" prop="familySurname1">
            <a-input v-model="form.familySurname1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人名1" prop="familyGivenName1">
            <a-input v-model="form.familyGivenName1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人性别1" prop="familySex1">
            <a-radio-group v-model="form.familySex1">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人生日期1" prop="familyBirth1">
            <a-date-picker style="width: 100%" v-model="form.familyBirth1" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人与您的关系1" prop="familyRelationship1">
            <a-select v-model="form.familyRelationship1" placeholder="请选择">
              <template v-if="model.visaType === 'Visitor'">
                <a-select-option v-for="item in relationshipList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
              <template v-if="model.visaType === 'Student'">
                <a-select-option v-for="item in relationshipForStudentList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template v-if="model.visaType === 'Student'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证号1" prop="familyNationalIdentification1">
              <a-input placeholder="" v-model="form.familyNationalIdentification1"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证有效期限1" prop="familyDateOfIdentification1">
              <a-range-picker style="width: 100%" v-model="form.familyDateOfIdentification1" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生省份1" prop="familyProvinceOfBirth1">
              <a-select placeholder="请选择" v-model="form.familyProvinceOfBirth1">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生城市1" prop="familyCityOfBirth1">
              <a-input placeholder="例如 广州" v-model="form.familyCityOfBirth1"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.familyRecord2 || form.familyRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addFamilyRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.familyRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人姓2" prop="familySurname2">
            <a-input v-model="form.familySurname2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人名2" prop="familyGivenName2">
            <a-input v-model="form.familyGivenName2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人性别2" prop="familySex2">
            <a-radio-group v-model="form.familySex2">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人生日期2" prop="familyBirth2">
            <a-date-picker style="width: 100%" v-model="form.familyBirth2" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人与您的关系2" prop="familyRelationship2">
            <a-select v-model="form.familyRelationship2" placeholder="请选择">
              <template v-if="model.visaType === 'Visitor'">
                <a-select-option v-for="item in relationshipList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
              <template v-if="model.visaType === 'Student'">
                <a-select-option v-for="item in relationshipForStudentList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-col>

        <template v-if="model.visaType === 'Student'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证号2" prop="familyNationalIdentification2">
              <a-input placeholder="" v-model="form.familyNationalIdentification2"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证有效期限2" prop="familyDateOfIdentification2">
              <a-range-picker style="width: 100%" v-model="form.familyDateOfIdentification2" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生省份2" prop="familyProvinceOfBirth2">
              <a-select placeholder="请选择" v-model="form.familyProvinceOfBirth2">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生城市2" prop="familyCityOfBirth2">
              <a-input placeholder="例如 广州" v-model="form.familyCityOfBirth2"/>
            </a-form-model-item>
          </a-col>
        </template>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.familyRecord3 || form.familyRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addFamilyRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeFamilyRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.familyRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人姓3" prop="familySurname3">
            <a-input v-model="form.familySurname3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人名3" prop="familyGivenName3">
            <a-input v-model="form.familyGivenName3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人性别3" prop="familySex3">
            <a-radio-group v-model="form.familySex3">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人生日期3" prop="familyBirth3">
            <a-date-picker style="width: 100%" v-model="form.familyBirth3" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人与您的关系3" prop="familyRelationship3">
            <a-select v-model="form.familyRelationship3" placeholder="请选择">

              <template v-if="model.visaType === 'Visitor'">
                <a-select-option v-for="item in relationshipList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
              <template v-if="model.visaType === 'Student'">
                <a-select-option v-for="item in relationshipForStudentList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>

            </a-select>
          </a-form-model-item>
        </a-col>
        <template v-if="model.visaType === 'Student'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证号3" prop="familyNationalIdentification3">
              <a-input placeholder="" v-model="form.familyNationalIdentification3"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证有效期限3" prop="familyDateOfIdentification3">
              <a-range-picker style="width: 100%" v-model="form.familyDateOfIdentification3" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生省份3" prop="familyProvinceOfBirth3">
              <a-select placeholder="请选择" v-model="form.familyProvinceOfBirth3">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生城市3" prop="familyCityOfBirth3">
              <a-input placeholder="例如 广州" v-model="form.familyCityOfBirth3"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.familyRecord4 || form.familyRecord4 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addFamilyRecord(4)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeFamilyRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.familyRecord4 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人姓4" prop="familySurname4">
            <a-input v-model="form.familySurname4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人名4" prop="familyGivenName4">
            <a-input v-model="form.familyGivenName4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人性别4" prop="familySex4">
            <a-radio-group v-model="form.familySex4">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人生日期4" prop="familyBirth4">
            <a-date-picker style="width: 100%" v-model="form.familyBirth4" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人与您的关系4" prop="familyRelationship4">
            <a-select v-model="form.familyRelationship4" placeholder="请选择">

              <template v-if="model.visaType === 'Visitor'">
                <a-select-option v-for="item in relationshipList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
              <template v-if="model.visaType === 'Student'">
                <a-select-option v-for="item in relationshipForStudentList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>

            </a-select>
          </a-form-model-item>
        </a-col>
        <template v-if="model.visaType === 'Student'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证号4" prop="familyNationalIdentification4">
              <a-input placeholder="" v-model="form.familyNationalIdentification4"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证有效期限4" prop="familyDateOfIdentification4">
              <a-range-picker style="width: 100%" v-model="form.familyDateOfIdentification4" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生省份4" prop="familyProvinceOfBirth4">
              <a-select placeholder="请选择" v-model="form.familyProvinceOfBirth4">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生城市4" prop="familyCityOfBirth4">
              <a-input placeholder="例如 广州" v-model="form.familyCityOfBirth4"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.familyRecord5 || form.familyRecord5 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addFamilyRecord(5)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeFamilyRecord(4)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.familyRecord5 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人姓5" prop="familySurname5">
            <a-input v-model="form.familySurname5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人名5" prop="familyGivenName5">
            <a-input v-model="form.familyGivenName5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人性别5" prop="familySex5">
            <a-radio-group v-model="form.familySex5">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人生日期5" prop="familyBirth5">
            <a-date-picker style="width: 100%" v-model="form.familyBirth5" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="家人与您的关系5" prop="familyRelationship5">
            <a-select v-model="form.familyRelationship5" placeholder="请选择">
              <template v-if="model.visaType === 'Visitor'">
                <a-select-option v-for="item in relationshipList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
              <template v-if="model.visaType === 'Student'">
                <a-select-option v-for="item in relationshipForStudentList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </template>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template v-if="model.visaType === 'Student'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证号5" prop="familyNationalIdentification5">
              <a-input placeholder="" v-model="form.familyNationalIdentification5"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人身份证有效期限5" prop="familyDateOfIdentification5">
              <a-range-picker style="width: 100%" v-model="form.familyDateOfIdentification5" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生省份5" prop="familyProvinceOfBirth5">
              <a-select placeholder="请选择" v-model="form.familyProvinceOfBirth5">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="家人出生城市5" prop="familyCityOfBirth5">
              <a-input placeholder="例如 广州" v-model="form.familyCityOfBirth5"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeFamilyRecord(5)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="工作/教育信息" style="margin-top: 24px">
      <template v-if="model.visaType === 'Visitor'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="工作状态" prop="workType">
              <a-select v-model="form.workType" placeholder="请选择">
                <a-select-option value="Employed">受雇</a-select-option>
                <a-select-option value="Self employed">自雇</a-select-option>
                <a-select-option value="Unemployed">失业</a-select-option>
                <a-select-option value="Retired">退休</a-select-option>
                <a-select-option value="Student">学生</a-select-option>
                <a-select-option value="Other">其他</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.workType === 'Employed' || form.workType === 'Self employed'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="工作分类" prop="occupationGroup">
              <a-select v-model="form.occupationGroup" placeholder="请选择">
                <a-select-option value="Managers">管理者</a-select-option>
                <a-select-option value="Professionals">专业人员</a-select-option>
                <a-select-option value="Technicians and Trades Workers">技术人员</a-select-option>
                <a-select-option value="Community and Personal Service Workers">社区和个人服务工作者</a-select-option>
                <a-select-option value="Clerical and Administrative Workers">文书和行政人员</a-select-option>
                <a-select-option value="Sales Workers">销售</a-select-option>
                <a-select-option value="Machinery Operators and Drivers">机械操作员和驾驶员</a-select-option>
                <a-select-option value="Labourers">体力劳动者</a-select-option>
                <a-select-option value="Other">其他</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.occupationGroup === 'Other'">
            <a-form-model-item label="工作说明" prop="occupationDetail">
              <a-input v-model="form.occupationDetail"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="现公司名称" prop="companyName">
              <a-input v-model="form.companyName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="入职日期" prop="startWorkDate">
              <a-date-picker style="width: 100%" v-model="form.startWorkDate" placeholder="请选择"
                             value-format="YYYY-MM-DD"
                             :disabled-date="afterNow"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司联系电话" prop="companyPhoneNumber">
              <a-input placeholder="例如 13900000000" v-model="form.companyPhoneNumber"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司联系邮箱" prop="companyEmail">
              <a-input placeholder="例如 xxx@gmail.com" v-model="form.companyEmail"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.workType === 'Employed' || form.workType === 'Self employed'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司地址省份" prop="companyAddressForProvince">
              <a-select placeholder="请选择" v-model="form.companyAddressForProvince">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司地址城市" prop="companyAddressForCity">
              <a-input placeholder="例如 广州" v-model="form.companyAddressForCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司地址" prop="companyAddressForStreet">
              <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.companyAddressForStreet"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司地址邮编" prop="companyAddressForZipCode">
              <a-input placeholder="例如 00000" v-model="form.companyAddressForZipCode"/>
            </a-form-model-item>
          </a-col>

        </a-row>
        <a-row class="form-row" v-if="form.workType === 'Employed' || form.workType === 'Self employed'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司联系人姓" prop="companyContactFamilyName">
              <a-input placeholder="例如 00000" v-model="form.companyContactFamilyName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司联系人名" prop="companyContactGivenName">
              <a-input placeholder="例如 00000" v-model="form.companyContactGivenName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司联系人职务" prop="companyContactPosition">
              <a-input placeholder="例如 00000" v-model="form.companyContactPosition"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="公司联系人电话" prop="companyContactPhone">
              <a-input placeholder="例如 00000" v-model="form.companyContactPhone"/>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row class="form-row" v-if="form.workType === 'Unemployed'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="失业开始日期" prop="unemployedDate">
              <a-date-picker style="width: 100%" v-model="form.unemployedDate" placeholder="请选择"
                             value-format="YYYY-MM-DD"
                             :disabled-date="beforeBirthday"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="最后的岗位" prop="unemployedPosition">
              <a-input v-model="form.unemployedPosition"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.workType === 'Retired'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="退休日期" prop="retiredDate">
              <a-date-picker style="width: 100%" v-model="form.retiredDate" placeholder="请选择"
                             value-format="YYYY-MM-DD"
                             :disabled-date="beforeBirthday"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.workType === 'Student'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="学校名称" prop="institutionName">
              <a-input v-model="form.institutionName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="课程名" prop="courseName">
              <a-input v-model="form.courseName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="学习日期" prop="dateOfStudy">
              <a-range-picker style="width: 100%" v-model="form.dateOfStudy" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.workType === 'Other'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="其他说明" prop="otherForWork">
              <a-input v-model="form.otherForWork"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
      <template v-if="model.visaType === 'Student'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="现学历(非在澳)" prop="highestOfSchool">
              <a-select v-model="form.highestOfSchool" placeholder="请选择">
                <a-select-option value="Secondary school - Year 12 or equivalent">中学</a-select-option>
                <a-select-option value="Vocational qualification - Diploma or equivalent">职业资格 - 文凭或同等学历
                </a-select-option>
                <a-select-option value="Bachelor degree (including honours) or equivalent">学士学位</a-select-option>
                <a-select-option value="Masters degree or equivalent">硕士学位</a-select-option>
                <a-select-option value="Doctoral degree or equivalent">博士学位</a-select-option>
                <a-select-option value="Not completed any schooling">未完成任何学业</a-select-option>
                <a-select-option value="Other">其他</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row"
               v-if="form.highestOfSchool === 'Secondary school - Year 12 or equivalent' || form.highestOfSchool === 'Vocational qualification - Diploma or equivalent' ||
               form.highestOfSchool === 'Bachelor degree (including honours) or equivalent'|| form.highestOfSchool === 'Masters degree or equivalent'||
               form.highestOfSchool === 'Doctoral degree or equivalent'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="学校名称" prop="highestOfInstitutionName">
              <a-input v-model="form.highestOfInstitutionName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="课程名/专业" prop="highestOfCourseName">
              <a-input v-model="form.highestOfCourseName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在读日期" prop="highestOfStudyDate">
              <a-range-picker style="width: 100%" v-model="form.highestOfStudyDate" value-format="YYYY-MM-DD"
                              :placeholder="['入学日期', '毕业日期']"
                              :disabled-date="afterNow" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>


    </a-card>
    <a-card title="入境信息" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="最近大使馆" prop="visaLocation">
            <a-select v-model="form.visaLocation" placeholder="请选择">
              <a-select-option value="China, Beijing">北京</a-select-option>
              <a-select-option value="China, Guangzhou">广州</a-select-option>
              <a-select-option value="China, Shanghai">上海</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="本次之后再入境" prop="intendOfMore">
            <a-radio-group v-model="form.intendOfMore">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.intendOfMore === 'Yes'">
          <a-form-model-item label="再入境原因" prop="reasonIntend">
            <a-input v-model="form.reasonIntend"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="抵达澳洲时间" prop="startDateOfIntend">
            <a-date-picker style="width: 100%" v-model="form.startDateOfIntend" placeholder="抵达日期"
                           value-format="YYYY-MM-DD" :disabled-date="beforeNow"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="离开澳洲时间" prop="endDateOfIntend">
            <a-date-picker style="width: 100%" v-model="form.endDateOfIntend" placeholder="离开日期"
                           value-format="YYYY-MM-DD" :disabled-date="beforeDateOfIntend"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <template v-if="model.visaType === 'Visitor'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="入境经费" prop="financialSupport">
              <a-select v-model="form.financialSupport" placeholder="请选择">
                <a-select-option value="1">自费</a-select-option>
                <a-select-option value="2">海外雇主</a-select-option>
                <a-select-option value="3">其他组织</a-select-option>
                <a-select-option value="4">其他人</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '1'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持在澳说明" prop="reasonSelf">
              <a-input v-model="form.reasonSelf"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '2'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持方面" prop="supportTypeOversea">
              <a-select v-model="form.supportTypeOversea" placeholder="请选择">
                <a-select-option value="Financial">Financial</a-select-option>
                <a-select-option value="Accommodation">Accommodation</a-select-option>
                <a-select-option value="All costs">All costs</a-select-option>
                <a-select-option value="Other">Other</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持在澳说明" prop="reasonOversea">
              <a-input v-model="form.reasonOversea"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '3'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持方面" prop="supportTypeOrganisation">
              <a-select v-model="form.supportTypeOrganisation" placeholder="请选择">
                <a-select-option value="Financial">Financial</a-select-option>
                <a-select-option value="Accommodation">Accommodation</a-select-option>
                <a-select-option value="All costs">All costs</a-select-option>
                <a-select-option value="Other">Other</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持在澳说明" prop="reasonOrganisation">
              <a-input v-model="form.reasonOrganisation"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="组织地址省份" prop="organisationAddressForProvince">
              <a-select placeholder="请选择" v-model="form.organisationAddressForProvince">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="组织地址城市" prop="organisationAddressForCity">
              <a-input placeholder="例如 广州" v-model="form.organisationAddressForCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="组织地址" prop="organisationAddressForStreet">
              <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.organisationAddressForStreet"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="组织地址邮编" prop="organisationAddressForZipCode">
              <a-input placeholder="例如 00000" v-model="form.organisationAddressForZipCode"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '4'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持方面" prop="supportTypePerson">
              <a-select v-model="form.supportTypePerson" placeholder="请选择">
                <a-select-option value="Financial">Financial</a-select-option>
                <a-select-option value="Accommodation">Accommodation</a-select-option>
                <a-select-option value="All costs">All costs</a-select-option>
                <a-select-option value="Other">Other</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持在澳说明" prop="reasonPerson">
              <a-input v-model="form.reasonPerson"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="与本人关系" prop="relationshipApplicant">
              <a-select v-model="form.relationshipApplicant" placeholder="请选择">
                <a-select-option v-for="item in relationshipList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持人的姓(拼音)" prop="surnamePerson">
              <a-input v-model="form.surnamePerson" placeholder="例如 li"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持人的名(拼音)" prop="givenNamePerson">
              <a-input v-model="form.givenNamePerson" placeholder="例如 xinan"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '4'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持人的地址省份" prop="personAddressForProvince">
              <a-select placeholder="请选择" v-model="form.personAddressForProvince">
                <a-select-option v-for="item in provinceList" :key="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持人的地址城市" prop="personAddressForCity">
              <a-input placeholder="例如 广州" v-model="form.personAddressForCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持人的地址" prop="personAddressForStreet">
              <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.personAddressForStreet"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="支持人的地址邮编" prop="personAddressForZipCode">
              <a-input placeholder="例如 00000" v-model="form.personAddressForZipCode"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
      <template v-if="model.visaType === 'Student'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="入境经费" prop="financialSupport">
              <a-select v-model="form.financialSupport" placeholder="请选择">
                <a-select-option value="1">政府奖学金</a-select-option>
                <a-select-option value="2">其他组织奖学金</a-select-option>
                <a-select-option value="3">自费</a-select-option>
                <a-select-option value="4">他人出资</a-select-option>
                <a-select-option value="5">其他</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '1'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="经费说明" prop="governmentScholarshipDesc">
              <a-input v-model="form.governmentScholarshipDesc"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '2'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="经费说明" prop="organisationScholarshipDesc">
              <a-input v-model="form.organisationScholarshipDesc"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '3'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳洲费用(AU$)" prop="personalScholarCost">
              <a-input-number style="width: 100%" v-model="form.personalScholarCost" :min="100"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="经费说明" prop="personalScholarshipDesc">
              <a-input v-model="form.personalScholarshipDesc"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '4'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="与本人关系" prop="otherPepleForRelationship">
              <a-select v-model="form.otherPeopleForRelationship" placeholder="请选择">
                <a-select-option value="Parent">父母</a-select-option>
                <a-select-option value="Spouse/De Facto Partner">伴侣</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳洲费用(AU$)" prop="otherPeopleScholarshipCost">
              <a-input-number style="width: 100%" v-model="form.otherPeopleScholarshipCost" :min="100"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="经费说明" prop="otherPeopleScholarshipDesc">
              <a-input v-model="form.otherPeopleScholarshipDesc"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row" v-if="form.financialSupport === '5'">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="经费说明" prop="otherScholarshipDesc">
              <a-input v-model="form.otherScholarshipDesc"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
    </a-card>
    <a-card title="旅行信息" style="margin-top: 24px" v-if="model.visaType === 'Visitor'">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="签证目的" prop="visaPurpose">
            <a-select v-model="form.visaPurpose" placeholder="请选择">
              <a-select-option value="Business Visitor stream">商务(会议)</a-select-option>
              <a-select-option value="Tourist stream">旅游类(旅游或探亲访友)</a-select-option>
              <a-select-option value="Student">学生</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="行程详细说明" prop="tripDetail">
            <a-input v-model="form.tripDetail"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.visaPurpose === 'Tourist stream'">
          <a-form-model-item label="访问的亲朋" prop="hasVisitRelatives">
            <a-radio-group v-model="form.hasVisitRelatives">
              <a-radio value="Yes">有</a-radio>
              <a-radio value="No">没</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.visaPurpose === 'Business Visitor stream'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在澳活动" prop="hasActivity">
            <a-select v-model="form.hasActivity" placeholder="请选择">
              <a-select-option value="Meetings">Meetings</a-select-option>
              <a-select-option value="Conferences">Conferences</a-select-option>
              <a-select-option value="Negotiations">Negotiations</a-select-option>
              <a-select-option value="Other">Other</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="活动主题" prop="activity">
            <a-input v-model="form.activity"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="活动地点" prop="location">
            <a-input v-model="form.location"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="活动时间" prop="dateOfActivity">
            <a-range-picker style="width: 100%" v-model="form.dateOfActivity" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <template v-if="form.visaPurpose === 'Business Visitor stream'">
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳组织" prop="organisationName">
              <a-input v-model="form.organisationName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳组织地址州" prop="aAddressForProvince">
              <a-select v-model="form.aAddressForProvince" placeholder="请选择">
                <a-select-option value="ACT">Australian Capital Territory</a-select-option>
                <a-select-option value="NSW">New South Wales</a-select-option>
                <a-select-option value="NT">Northern Territory</a-select-option>
                <a-select-option value="QLD">Queensland</a-select-option>
                <a-select-option value="SA">South Australia</a-select-option>
                <a-select-option value="TAS">Tasmania</a-select-option>
                <a-select-option value="VIC">Victoria</a-select-option>
                <a-select-option value="WA">Western Australia</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳组组织地址城市" prop="aAddressForCity">
              <a-input placeholder="例如 广州" v-model="form.aAddressForCity"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳组组织地址" prop="aAddressForStreet">
              <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.aAddressForStreet"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳组组织地址邮编" prop="aAddressForZipCode">
              <a-input placeholder="例如 00000" v-model="form.aAddressForZipCode"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row class="form-row">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳联系人姓" prop="contactFamilyName">
              <a-input placeholder="例如 00000" v-model="form.contactFamilyName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳联系人名" prop="contactGivenName">
              <a-input placeholder="例如 00000" v-model="form.contactGivenName"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳联系人职务" prop="contactPosition">
              <a-input placeholder="例如 00000" v-model="form.contactPosition"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳联系人电话" prop="contactPhone">
              <a-input placeholder="例如 00000" v-model="form.contactPhone"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="在澳联系人邮箱" prop="contactEmail">
              <a-input placeholder="例如 xxx@gmail.com" v-model="form.contactEmail"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </template>
      <template v-if="form.visaPurpose === 'Tourist stream'">
        <template v-if="form.hasVisitRelatives === 'Yes'">
          <a-row class="form-row">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋姓氏1" prop="relativeSurnames1">
                <a-input v-model="form.relativeSurnames1" placeholder="例如 zhang"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋名称1" prop="relativeGivenNames1">
                <a-input v-model="form.relativeGivenNames1" placeholder="例如 san"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋性别1" prop="relativeSex1">
                <a-radio-group v-model="form.relativeSex1">
                  <a-radio value="Male">男</a-radio>
                  <a-radio value="Female">女</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋生日期1" prop="relativeBirth1">
                <a-date-picker style="width: 100%" v-model="form.relativeBirth1" placeholder="请选择"
                               value-format="YYYY-MM-DD"/>
              </a-form-model-item>
            </a-col>

          </a-row>
          <a-row class="form-row">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址州1" prop="relativeState1">
                <a-select v-model="form.relativeState1" placeholder="请选择">
                  <a-select-option value="ACT">Australian Capital Territory</a-select-option>
                  <a-select-option value="NSW">New South Wales</a-select-option>
                  <a-select-option value="NT">Northern Territory</a-select-option>
                  <a-select-option value="QLD">Queensland</a-select-option>
                  <a-select-option value="SA">South Australia</a-select-option>
                  <a-select-option value="TAS">Tasmania</a-select-option>
                  <a-select-option value="VIC">Victoria</a-select-option>
                  <a-select-option value="WA">Western Australia</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址城市1" prop="relativeCity1">
                <a-input placeholder="例如 广州" v-model="form.relativeCity1"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址1" prop="relativeStreet1">
                <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.relativeStreet1"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址邮编1" prop="relativeZipCode1">
                <a-input placeholder="例如 00000" v-model="form.relativeZipCode1"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋身份1" prop="relativeResidency1">
                <a-select v-model="form.relativeResidency1" placeholder="请选择">
                  <a-select-option value="Australian Citizen">公民</a-select-option>
                  <a-select-option value="Australian Permanent Resident">永久居民</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Student)">临时居民(学生)</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Visitor)">临时居民(旅游)</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Work visa)">临时居民(工作)</a-select-option>
                  <a-select-option value="Other">其他</a-select-option>
                  <a-select-option value="Unknown">未知</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="与本人关系1" prop="relationship1">
                <a-select v-model="form.relationship1" placeholder="请选择">
                  <a-select-option v-for="item in relationshipList" :key="item.value">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="在澳联系人电话1" prop="relativePhone1">
                <a-input placeholder="例如 00000" v-model="form.relativePhone1"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="在澳联系人邮箱1" prop="relativeEmail1">
                <a-input placeholder="例如 xxx@gmail.com" v-model="form.relativeEmail1"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
                   v-if="!form.relativeRecord2 || form.relativeRecord2 === 'No'">
              <a-form-model-item>
                <a-icon class="dynamic-add-button" type="plus-circle" @click="addRelativeRecord(2)"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row" v-if="form.relativeRecord2 === 'Yes'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋姓氏2" prop="relativeSurnames2">
                <a-input v-model="form.relativeSurnames2" placeholder="例如 zhang"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋名称2" prop="relativeGivenNames2">
                <a-input v-model="form.relativeGivenNames2" placeholder="例如 san"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋性别2" prop="relativeSex2">
                <a-radio-group v-model="form.relativeSex2">
                  <a-radio value="Male">男</a-radio>
                  <a-radio value="Female">女</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋生日期2" prop="relativeBirth2">
                <a-date-picker style="width: 100%" v-model="form.relativeBirth2" placeholder="请选择"
                               value-format="YYYY-MM-DD"/>
              </a-form-model-item>
            </a-col>


          </a-row>
          <a-row class="form-row" v-if="form.relativeRecord2 === 'Yes'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址州2" prop="relativeState2">
                <a-select v-model="form.relativeState2" placeholder="请选择">
                  <a-select-option value="ACT">Australian Capital Territory</a-select-option>
                  <a-select-option value="NSW">New South Wales</a-select-option>
                  <a-select-option value="NT">Northern Territory</a-select-option>
                  <a-select-option value="QLD">Queensland</a-select-option>
                  <a-select-option value="SA">South Australia</a-select-option>
                  <a-select-option value="TAS">Tasmania</a-select-option>
                  <a-select-option value="VIC">Victoria</a-select-option>
                  <a-select-option value="WA">Western Australia</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址城市2" prop="relativeCity2">
                <a-input placeholder="例如 广州" v-model="form.relativeCity2"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址2" prop="relativeStreet2">
                <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.relativeStreet2"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址邮编2" prop="relativeZipCode2">
                <a-input placeholder="例如 00000" v-model="form.relativeZipCode2"/>
              </a-form-model-item>
            </a-col>

          </a-row>
          <a-row class="form-row" v-if="form.relativeRecord2 === 'Yes'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋身份2" prop="relativeResidency2">
                <a-select v-model="form.relativeResidency2" placeholder="请选择">
                  <a-select-option value="Australian Citizen">公民</a-select-option>
                  <a-select-option value="Australian Permanent Resident">永久居民</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Student)">临时居民(学生)</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Visitor)">临时居民(旅游)</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Work visa)">临时居民(工作)</a-select-option>
                  <a-select-option value="Other">其他</a-select-option>
                  <a-select-option value="Unknown">未知</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="与本人关系2" prop="relationship2">
                <a-select v-model="form.relationship2" placeholder="请选择">
                  <a-select-option v-for="item in relationshipList" :key="item.value">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="在澳联系人电话2" prop="relativePhone2">
                <a-input placeholder="例如 00000" v-model="form.relativePhone2"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="在澳联系人邮箱2" prop="relativeEmail2">
                <a-input placeholder="例如 xxx@gmail.com" v-model="form.relativeEmail2"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
                   v-if="!form.relativeRecord3 || form.relativeRecord3 === 'No'">
              <a-form-model-item>
                <a-icon class="dynamic-add-button" type="plus-circle" @click="addRelativeRecord(3)"/>
                <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeRelativeRecord(2)"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row class="form-row" v-if="form.relativeRecord3 === 'Yes'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋姓氏3" prop="relativeSurnames3">
                <a-input v-model="form.relativeSurnames3" placeholder="例如 zhang"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋名称3" prop="relativeGivenNames3">
                <a-input v-model="form.relativeGivenNames3" placeholder="例如 san"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋性别3" prop="relativeSex3">
                <a-radio-group v-model="form.relativeSex3">
                  <a-radio value="Male">男</a-radio>
                  <a-radio value="Female">女</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋生日期3" prop="relativeBirth3">
                <a-date-picker style="width: 100%" v-model="form.relativeBirth3" placeholder="请选择"
                               value-format="YYYY-MM-DD"/>
              </a-form-model-item>
            </a-col>

          </a-row>
          <a-row class="form-row" v-if="form.relativeRecord3 === 'Yes'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址州3" prop="relativeState3">
                <a-select v-model="form.relativeState3" placeholder="请选择">
                  <a-select-option value="ACT">Australian Capital Territory</a-select-option>
                  <a-select-option value="NSW">New South Wales</a-select-option>
                  <a-select-option value="NT">Northern Territory</a-select-option>
                  <a-select-option value="QLD">Queensland</a-select-option>
                  <a-select-option value="SA">South Australia</a-select-option>
                  <a-select-option value="TAS">Tasmania</a-select-option>
                  <a-select-option value="VIC">Victoria</a-select-option>
                  <a-select-option value="WA">Western Australia</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址城市3" prop="relativeCity3">
                <a-input placeholder="例如 广州" v-model="form.relativeCity3"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址3" prop="relativeStreet3">
                <a-input placeholder="例如 白云区 珠江新城01号" v-model="form.relativeStreet3"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋地址邮编3" prop="relativeZipCode3">
                <a-input placeholder="例如 00000" v-model="form.relativeZipCode3"/>
              </a-form-model-item>
            </a-col>

          </a-row>
          <a-row class="form-row" v-if="form.relativeRecord3 === 'Yes'">
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="亲朋身份3" prop="relativeResidency3">
                <a-select v-model="form.relativeResidency3" placeholder="请选择">
                  <a-select-option value="Australian Citizen">公民</a-select-option>
                  <a-select-option value="Australian Permanent Resident">永久居民</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Student)">临时居民(学生)</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Visitor)">临时居民(旅游)</a-select-option>
                  <a-select-option value="Australian Temporary Resident (Work visa)">临时居民(工作)</a-select-option>
                  <a-select-option value="Other">其他</a-select-option>
                  <a-select-option value="Unknown">未知</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="与本人关系1" prop="relationship3">
                <a-select v-model="form.relationship3" placeholder="请选择">
                  <a-select-option v-for="item in relationshipList" :key="item.value">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="在澳联系人电话3" prop="relativePhone3">
                <a-input placeholder="例如 00000" v-model="form.relativePhone3"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item label="在澳联系人邮箱3" prop="relativeEmail3">
                <a-input placeholder="例如 xxx@gmail.com" v-model="form.relativeEmail3"/>
              </a-form-model-item>
            </a-col>
            <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
              <a-form-model-item>
                <a-icon class="dynamic-delete-button" type="minus-circle" @click="removeRelativeRecord(3)"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </template>
      </template>
    </a-card>
    <a-card title="学签信息" style="margin-top: 24px" v-if="model.visaType === 'Student'">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4" v-if="form.visaPurpose === 'Tourist stream'">
          <a-form-model-item label="首次申请学签证" prop="hasFirstStudent">
            <a-radio-group v-model="form.hasFirstStudent">
              <a-radio value="Yes">有</a-radio>
              <a-radio value="No">没</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="CoE 编号" prop="coeNumber">
            <a-input placeholder="CoE 编号" v-model="form.coeNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="教育领域" prop="educationSector">
            <a-select v-model="form.educationSector" placeholde="请选择">
              <a-select-option value="Higher Education Sector">Higher Education Sector</a-select-option>
              <a-select-option value="Schools Sector">Schools Sector</a-select-option>
              <a-select-option value="Foreign Affairs or Defence Sector">Foreign Affairs or Defence Sector
              </a-select-option>
              <a-select-option value="Independent ELICOS Sector">Independent ELICOS Sector</a-select-option>
              <a-select-option value="Non-Award Sector">Non-Award Sector</a-select-option>
              <a-select-option value="Postgraduate Research Sector">Postgraduate Research Sector</a-select-option>
              <a-select-option value="Vocational Education and Training Sector">Vocational Education and Training
                Sector
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="学习类型" prop="evidenceType">
            <a-select v-model="form.evidenceType" placeholder="请选择">
              <a-select-option value="Letter of offer">录入通知书</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="课程代码" prop="courseCode">
            <a-input placeholder="课程代码" v-model="form.courseCode"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="课程名" prop="courseTitle">
            <a-input placeholder="课程名" v-model="form.courseTitle"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="教育机构代码" prop="educationCode">
            <a-input placeholder="教育机构代码" v-model="form.educationCode"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="教育机构" prop="educationTitle">
            <a-input placeholder="教育机构" v-model="form.educationTitle"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="课程时间" prop="dateOfCourse">
            <a-range-picker style="width: 100%" v-model="form.dateOfCourse" value-format="YYYY-MM-DD"
                            :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="支持学业经济信息" prop="economicDesc">
            <a-input v-model="form.economicDesc"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在澳学习原因" prop="studyReasonDesc">
            <a-input v-model="form.studyReasonDesc"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="完成学业好处" prop="studyCompleteDesc">
            <a-input v-model="form.studyCompleteDesc"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="其他学业相关信息" prop="otherStudyDesc">
            <a-input v-model="form.otherStudyDesc"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="在澳学习历史信息" prop="studyHistoryDesc">
            <a-input v-model="form.studyHistoryDesc"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="旅行同伴" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="有同行人" prop="hasCompanion">
            <a-radio-group v-model="form.hasCompanion">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasCompanion === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓1" prop="companionSurname1">
            <a-input v-model="form.companionSurname1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名1" prop="companionGivenName1">
            <a-input v-model="form.companionGivenName1"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人性别1" prop="companionSex1">
            <a-radio-group v-model="form.companionSex1">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人生日期1" prop="companionBirth1">
            <a-date-picker style="width: 100%" v-model="form.companionBirth1" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系1" prop="companionRelationship1">
            <a-select v-model="form.companionRelationship1" placeholder="请选择">
              <a-select-option v-for="item in relationshipList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template
            v-if="(moment().diff(model.birthday, 'year', false)) < 16 && (form.companionRelationship1 === 'Parent')">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照号1" prop="companionPassportNumber1">
              <a-input v-model="form.companionPassportNumber1" placeholder="例如 EB8195***"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照有效期限1" prop="companionDateOfPassport1">
              <a-range-picker style="width: 100%" v-model="form.companionDateOfPassport1" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照签发地1" prop="companionPlaceOfPassport1">
              <a-input placeholder="例如 广东" v-model="form.companionPlaceOfPassport1"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="TRN1" prop="companionTRN1">
              <a-input placeholder="Transaction Reference Number" v-model="form.companionTRN1"/>
            </a-form-model-item>
          </a-col>
        </template>

        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.companionRecord2 || form.companionRecord2 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addCompanionRecord(2)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasCompanion === 'Yes' && form.companionRecord2 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓2" prop="companionSurname2">
            <a-input v-model="form.companionSurname2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名2" prop="companionGivenName2">
            <a-input v-model="form.companionGivenName2"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人性别2" prop="companionSex2">
            <a-radio-group v-model="form.companionSex2">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人生日期2" prop="companionBirth2">
            <a-date-picker style="width: 100%" v-model="form.companionBirth2" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系2" prop="companionRelationship2">
            <a-select v-model="form.companionRelationship2" placeholder="请选择">
              <a-select-option v-for="item in relationshipList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template
            v-if="(moment().diff(model.birthday, 'year', false)) < 16 && (form.companionRelationship2 === 'Parent')">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照号2" prop="companionPassportNumber2">
              <a-input v-model="form.companionPassportNumber2" placeholder="例如 EB8195***"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照有效期限2" prop="companionDateOfPassport2">
              <a-range-picker style="width: 100%" v-model="form.companionDateOfPassport2" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照签发地2" prop="companionPlaceOfPassport2">
              <a-input placeholder="例如 广东" v-model="form.companionPlaceOfPassport2"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="TRN1" prop="companionTRN2">
              <a-input placeholder="Transaction Reference Number" v-model="form.companionTRN2"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.companionRecord3 || form.companionRecord3 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addCompanionRecord(3)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeCompanionRecord(2)"/>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row class="form-row" v-if="form.hasCompanion === 'Yes' && form.companionRecord3 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓3" prop="companionSurname3">
            <a-input v-model="form.companionSurname3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名3" prop="companionGivenName3">
            <a-input v-model="form.companionGivenName3"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人性别3" prop="companionSex3">
            <a-radio-group v-model="form.companionSex3">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人生日期3" prop="companionBirth3">
            <a-date-picker style="width: 100%" v-model="form.companionBirth3" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系3" prop="companionRelationship3">
            <a-select v-model="form.companionRelationship3" placeholder="请选择">
              <a-select-option v-for="item in relationshipList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template
            v-if="(moment().diff(model.birthday, 'year', false)) < 16 && (form.companionRelationship3 === 'Parent')">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照号3" prop="companionPassportNumber3">
              <a-input v-model="form.companionPassportNumber3" placeholder="例如 EB8195***"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照有效期限3" prop="companionDateOfPassport3">
              <a-range-picker style="width: 100%" v-model="form.companionDateOfPassport3" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照签发地3" prop="companionPlaceOfPassport3">
              <a-input placeholder="例如 广东" v-model="form.companionPlaceOfPassport3"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="TRN3" prop="companionTRN3">
              <a-input placeholder="Transaction Reference Number" v-model="form.companionTRN3"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.companionRecord4 || form.companionRecord4 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addCompanionRecord(4)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeCompanionRecord(3)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasCompanion === 'Yes' && form.companionRecord4 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓4" prop="companionSurname4">
            <a-input v-model="form.companionSurname4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名4" prop="companionGivenName4">
            <a-input v-model="form.companionGivenName4"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人性别4" prop="companionSex4">
            <a-radio-group v-model="form.companionSex4">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人生日期4" prop="companionBirth4">
            <a-date-picker style="width: 100%" v-model="form.companionBirth4" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系4" prop="companionRelationship4">
            <a-select v-model="form.companionRelationship4" placeholder="请选择">
              <a-select-option v-for="item in relationshipList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template
            v-if="(moment().diff(model.birthday, 'year', false)) < 16 && (form.companionRelationship4 === 'Parent')">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照号4" prop="companionPassportNumbe4">
              <a-input v-model="form.companionPassportNumber4" placeholder="例如 EB8195***"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照有效期限4" prop="companionDateOfPassport4">
              <a-range-picker style="width: 100%" v-model="form.companionDateOfPassport4" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照签发地4" prop="companionPlaceOfPassport4">
              <a-input placeholder="例如 广东" v-model="form.companionPlaceOfPassport4"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="TRN4" prop="companionTRN4">
              <a-input placeholder="Transaction Reference Number" v-model="form.companionTRN4"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.companionRecord5 || form.companionRecord5 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addCompanionRecord(5)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeCompanionRecord(4)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasCompanion === 'Yes' && form.companionRecord5 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓5" prop="companionSurname5">
            <a-input v-model="form.companionSurname5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名5" prop="companionGivenName5">
            <a-input v-model="form.companionGivenName5"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人性别5" prop="companionSex5">
            <a-radio-group v-model="form.companionSex5">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人生日期5" prop="companionBirth5">
            <a-date-picker style="width: 100%" v-model="form.companionBirth5" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系5" prop="companionRelationship5">
            <a-select v-model="form.companionRelationship5" placeholder="请选择">
              <a-select-option v-for="item in relationshipList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template
            v-if="(moment().diff(model.birthday, 'year', false)) < 16 && (form.companionRelationship5 === 'Parent')">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照号5" prop="companionPassportNumbe5">
              <a-input v-model="form.companionPassportNumber5" placeholder="例如 EB8195***"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照有效期限5" prop="companionDateOfPassport5">
              <a-range-picker style="width: 100%" v-model="form.companionDateOfPassport5" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照签发地5" prop="companionPlaceOfPassport5">
              <a-input placeholder="例如 广东" v-model="form.companionPlaceOfPassport5"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="TRN5" prop="companionTRN5">
              <a-input placeholder="Transaction Reference Number" v-model="form.companionTRN5"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4"
               v-if="!form.companionRecord6 || form.companionRecord6 === 'No'">
          <a-form-model-item>
            <a-icon class="dynamic-add-button" type="plus-circle" @click="addCompanionRecord(6)"/>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeCompanionRecord(5)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row" v-if="form.hasCompanion === 'Yes' && form.companionRecord6 === 'Yes'">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人姓6" prop="companionSurname6">
            <a-input v-model="form.companionSurname6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人名6" prop="companionGivenName6">
            <a-input v-model="form.companionGivenName6"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人性别6" prop="companionSex6">
            <a-radio-group v-model="form.companionSex6">
              <a-radio value="Male">男</a-radio>
              <a-radio value="Female">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人生日期6" prop="companionBirth6">
            <a-date-picker style="width: 100%" v-model="form.companionBirth6" placeholder="请选择"
                           value-format="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="同行人与您的关系6" prop="companionRelationship6">
            <a-select v-model="form.companionRelationship6" placeholder="请选择">
              <a-select-option v-for="item in relationshipList" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <template
            v-if="(moment().diff(model.birthday, 'year', false)) < 16 && (form.companionRelationship6 === 'Parent')">
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照号6" prop="companionPassportNumbe6">
              <a-input v-model="form.companionPassportNumber6" placeholder="例如 EB8195***"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照有效期限6" prop="companionDateOfPassport6">
              <a-range-picker style="width: 100%" v-model="form.companionDateOfPassport6" value-format="YYYY-MM-DD"
                              :placeholder="['开始日期', '结束日期']" :inputReadOnly="true"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="护照签发地6" prop="companionPlaceOfPassport6">
              <a-input placeholder="例如 广东" v-model="form.companionPlaceOfPassport6"/>
            </a-form-model-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
            <a-form-model-item label="TRN6" prop="companionTRN6">
              <a-input placeholder="Transaction Reference Number" v-model="form.companionTRN6"/>
            </a-form-model-item>
          </a-col>
        </template>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item>
            <a-icon class="dynamic-delete-button" type="minus-circle"
                    @click="removeCompanionRecord(6)"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-card title="旅行历史" style="margin-top: 24px">
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否申请过澳签" prop="hasVisa">
            <a-radio-group v-model="form.hasVisa">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="是否去过澳洲" prop="hasTravelled">
            <a-radio-group v-model="form.hasTravelled">
              <a-radio value="Yes">是</a-radio>
              <a-radio value="No">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="澳签grant number" prop="grantNumber">
            <a-input placeholder="grant number" v-model="form.grantNumber"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="中国商务代码" prop="commercialCode">
            <a-input placeholder="Chinese commercial code" v-model="form.commercialCode"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="它国签证记录" prop="otherVisa">
            <a-input placeholder="细节" v-model="form.otherVisa"/>
          </a-form-model-item>
        </a-col>
        <a-col :sm="12" :md="12" :lg="8" :xl="6" :xxl="4">
          <a-form-model-item label="它国拒签记录" prop="otherRefuse">
            <a-input placeholder="细节" v-model="form.otherRefuse"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-card>
    <a-modal :visible="applyVisible" :footer="null" :closable="false" :maskClosable="false">
      <a-alert message="资料提交使馆中，请不要关闭或刷新浏览器..." type="warning" show-icon/>
      <div v-if="applySpinVisible"
           style="display: flex; justify-content: center; align-items: center; height: 150px;">
        <a-spin/>
      </div>

      <div v-if="applyInputVisible"
           style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 16px; height: 150px;">
        <a-input placeholder="输入安全码" style="width: 80%" v-model="form.securityCode"/>
        <a-button type="primary" @click="setSecurityCode()">确定提交</a-button>
      </div>

    </a-modal>
  </a-form-model>

</template>

<script>

import moment from 'moment';
import 'moment/locale/zh-cn';
import {HttpMixins} from "@/mixins/http-mixins";
import {WebSocketMixins} from "@/mixins/web-socket-mixins";

const pattern = {
  english: /^[A-Za-z][A-Za-z ]*$/,
  nationalIdentification: /^(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)|(^([A-Z]|[0-9]){5,17}$)$/,
  zipCode: /^([0-9]\d{4,5})$/,
  cellphone: /^(1[345789]\d{9})$/,
  phone: /^(\d{11,12})$/,
  mail: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  passportNumber: /^([A-Z]|[0-9]){5,17}$/,
  numberOrEnglish: /^[A-Za-z0-9][A-Za-z0-9 ]*$/,
  numberOrChinaOrEnglish: /^([\u4E00-\u9FA5\w\- ]+)$/,
  number: /^([0-9]*)$/,
  coe: /^([A-Z]|[0-9]){8,10}$/,
}


export default {
  name: "DetailCreateTable",
  mixins: [HttpMixins, WebSocketMixins],
  data() {
    return {
      moment,
      model: {},
      form: {},
      applyVisible: false,
      applySpinVisible: false,
      applyInputVisible: false,
      identityImg: {
        loading: false,
        name: 'identityImgUrl',
      },
      passportImg: {
        loading: false,
        name: 'passportImgUrl',
      },
      familyImg1: {
        loading: false,
        name: 'familyImgUrl1',
      },
      familyImg2: {
        loading: false,
        name: 'familyImgUrl2',
      },
      familyImg3: {
        loading: false,
        name: 'familyImgUrl3',
      },
      relationshipList: [
        {value: 'Parent', name: '父母'},
        {value: 'Child', name: '孩子'},
        {value: 'Grandparent', name: '祖父母'},
        {value: 'Grandchild', name: '孙子'},
        {value: 'Spouse/De Facto Partner', name: '配偶/事实伴侣'},
        {value: 'Daughter/Son-in-law', name: '媳妇/女婿'},
        {value: 'Fiance/Fiancee', name: '未婚夫/未婚妻'},
        {value: 'Friend', name: '朋友'},
        {value: 'Brother', name: '兄弟'},
        {value: 'Sister', name: '姐妹'},
        {value: 'Business Associate', name: '商业伙伴'},
        {value: 'Cousin', name: '堂(表)兄弟(姐妹)'},
        {value: 'Mother/Father-in-law', name: '岳母/岳父'},
        {value: 'Nephew', name: '侄子'},
        {value: 'Niece', name: '侄女'},
        {value: 'Uncle', name: '叔叔'},
        {value: 'Aunt', name: '阿姨'},
        {value: 'Step Child', name: '继子女'},
        {value: 'Step Parent', name: '继父母'},
        {value: 'Step-brother', name: '继兄弟'},
        {value: 'Step-sister', name: '继姐妹'},
      ],
      relationshipForStudentList: [
        {value: 'Parent', name: '父母'},
        {value: 'Spouse/De Facto Partner', name: '配偶/事实伴侣'},
        {value: 'Step Parent', name: '继父母'},
      ],
      countryList: [
        {value: 'HKON', name: '香港'},
        {value: 'MACS', name: '澳门'},
        {value: 'MONG', name: '蒙古'},
        {value: 'SKOR', name: '韩国'},
        {value: 'JAPA', name: '日本'},
        {value: 'TAIW', name: '台湾'},
        {value: 'BIOT', name: '印度'},
        {value: 'MALS', name: '马来西亚'},
        {value: 'MIS', name: '马尔代夫'},
        {value: 'SING', name: '新加坡'},
        {value: 'THAI', name: '泰国'},
        {value: 'VIET', name: '越南'},
        {value: 'LAOS', name: '老挝'},
        {value: 'CAMB', name: '柬埔寨'},
        {value: 'PHIL', name: '菲律宾'},
        {value: 'INDO', name: '印度尼西亚'},
        {value: 'PKSN', name: '巴基斯坦'},
        {value: 'FINL', name: '芬兰'},
        {value: 'FRAE', name: '法国'},
        {value: 'GERM', name: '德国'},
        {value: 'ITAL', name: '意大利'},
        {value: 'SPAI', name: '西班牙'},
        {value: 'UK', name: '英国'},
        {value: 'SWIT', name: '瑞士'},
        {value: 'SWED', name: '瑞典'},
        {value: 'GREE', name: '希腊'},
        {value: 'AUST', name: '奥地利'},
        {value: 'CZEH', name: '捷克'},
        {value: 'HUNG', name: '匈牙利'},
        {value: 'POLA', name: '波兰'},
        {value: 'NORW', name: '挪威'},
        {value: 'NETH', name: '荷兰'},
        {value: 'DENM', name: '丹麦'},
        {value: 'IREP', name: '爱尔兰'},
        {value: 'RFED', name: '俄罗斯'},
        {value: 'UKRA', name: '乌克兰'},
        {value: 'ISRA', name: '以色列'},
        {value: 'CANA', name: '加拿大'},
        {value: 'USA', name: '美国'},
        {value: 'MEXI', name: '墨西哥'},
        {value: 'BRAZ', name: '巴西'},
        {value: 'ARGE', name: '阿根廷'},
        {value: 'PERU', name: '秘鲁'},
        {value: 'COLA', name: '哥伦比亚'},
        {value: 'CHIL', name: '智利'},
        {value: 'URUG', name: '乌拉圭'},
        {value: 'NZEA', name: '新西兰'},
        {value: 'EGYP', name: '埃及'},
        {value: 'MORO', name: '摩洛哥'},
        {value: 'SAFR', name: '南非'},
        {value: 'MOZA', name: '莫桑比克'},
        {value: 'ECUA', name: '厄瓜多尔'},
        {value: 'UAEM', name: '阿联酋'},
        {value: 'SAAR', name: '沙特阿拉伯'},
        {value: 'TUNI', name: '突尼斯'},
      ],
      provinceList: [
        {name: '安徽', value: 'ANHUI SHENG'},
        {name: '北京', value: 'BEIJING SHI'},
        {name: '重庆', value: 'CHONGQING SHI'},
        {name: '福建', value: 'FUJIAN SHENG'},
        {name: '甘肃', value: 'GANSU SHENG'},
        {name: '广东', value: 'GUANGDONG SHENG'},
        {name: '广西', value: 'GUANGXI ZHUANGZU ZIZHIQU'},
        {name: '贵州', value: 'GUIZHOU SHENG'},
        {name: '海南', value: 'HAINAN SHENG'},
        {name: '河北', value: 'HEBEI SHENG'},
        {name: '黑龙江', value: 'HEILONGJIANG SHENG'},
        {name: '河南', value: 'HENAN SHENG'},
        {name: '湖北', value: 'HUBEI SHENG'},
        {name: '湖南', value: 'HUNAN SHENG'},
        {name: '江苏', value: 'JIANGSU SHENG'},
        {name: '江西', value: 'JIANGXI SHENG'},
        {name: '山西', value: 'SHANXI SHENG'},
        {name: '吉林', value: 'JILIN SHENG'},
        {name: '辽宁', value: 'LIAONING SHENG'},
        {name: '内蒙古', value: 'NEI MONGOL ZIZHIQU'},
        {name: '宁夏', value: 'NINGXIA HUIZU ZIZHIQU'},
        {name: '青海', value: 'QINGHAI SHENG'},
        {name: '山东', value: 'SHANDONG SHENG'},
        {name: '上海', value: 'SHANGHAI SHI'},
        {name: '陕西', value: 'SHAANXI SHENG'},
        {name: '四川', value: 'SICHUAN SHENG'},
        {name: '天津', value: 'TIANJIN SHI'},
        {name: '新疆', value: 'XINJIANG UYGUR ZIZHIQU'},
        {name: '西藏', value: 'XIZANG ZIZHIQU'},
        {name: '云南', value: 'YUNNAN SHENG'},
        {name: '浙江', value: 'ZHEJIANG SHENG'}
      ],
      rules: {
        otherName: [{required: true, message: '必填!'}],
        otherSurname: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        otherGivenName: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        sex: [{required: true, message: '必填!'}],
        hasNationalIdentification: [{required: true, message: '必填!'}],
        nationalIdentificationReason: [{required: true, message: '必填!'}],
        nationalIdentification: [{
          required: true,
          pattern: pattern.nationalIdentification,
          message: '必填,身份证格式!'
        }],
        startDateForIdCardNo: [{required: true, message: '必填!'}],
        endDateForIdCardNo: [{}],
        placeOfIdentification: [{required: true, message: '必填!'}],
        dateOfPassport: [{required: true, message: '必填!'}],
        startDateForPassport: [{required: true, message: '必填!'}],
        endDateForPassport: [{required: true, message: '必填!'}],
        placeOfPassport: [{required: true, message: '必填!'}],
        provinceOfBirth: [{required: true, message: '必填!'}],
        cityOfBirth: [{required: true, message: '必填!'}],
        maritalStatus: [{required: true, message: '必填!'}],

        fatherSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        fatherGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        fatherDateOfBirth: [{required: true, message: '必填!'}],
        motherSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        motherGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        motherDateOfBirth: [{required: true, message: '必填!'}],
        spouseSurnames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        spouseGivenNames: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        spouseDateOfBirth: [{required: true, message: '必填!'}],

        homeAddressForProvince: [{required: true, message: '必填!'}],
        homeAddressForCity: [{required: true, message: '必填!'}],
        homeAddressForStreet: [{required: true, message: '必填!'}],
        homeAddressForZipCode: [{pattern: pattern.zipCode, message: '5或6位数字!'}],
        primaryPhoneNumber: [{required: true, pattern: pattern.cellphone, message: '必填,请输入正确格式手机号!'}],
        secondaryPhoneNumber: [{pattern: pattern.phone, message: '请输入正确格式固话号!'}],
        workPhoneNumber: [{pattern: pattern.phone, message: '请输入正确格式固话号!'}],
        emailAddress: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],

        visaLocation: [{required: true, message: '必填!'}],

        startDateOfIntend: [{required: true, message: '必填!'}],
        endDateOfIntend: [{required: true, message: '必填!'}],

        intendOfMore: [{required: true, message: '必填!'}],
        reasonIntend: [{required: true, message: '必填!'}],
        financialSupport: [{required: true, message: '必填!'}],
        reasonSelf: [
          { required: true, message: '必填!' },
          { max: 80, message: '长度不超过 80 个中文字符', trigger: 'blur' },
        ],
        supportTypeOversea: [{required: true, message: '必填!'}],
        reasonOversea: [{required: true, message: '必填!'}],
        supportTypeOrganisation: [{required: true, message: '必填!'}],
        reasonOrganisation: [{required: true, message: '必填!'}],
        organisationAddressForProvince: [{required: true, message: '必填!'}],
        organisationAddressForCity: [{required: true, message: '必填!'}],
        organisationAddressForStreet: [{required: true, message: '必填!'}],
        organisationAddressForZipCode: [{required: true, pattern: pattern.zipCode, message: '5或6位数字!'}],
        supportTypePerson: [{required: true, message: '必填!'}],
        reasonPerson: [{required: true, message: '必填!'}],
        relationshipApplicant: [{required: true, message: '必填!'}],
        surnamePerson: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        givenNamePerson: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        personAddressForProvince: [{required: true, message: '必填!'}],
        personAddressForCity: [{required: true, message: '必填!'}],
        personAddressForStreet: [{required: true, message: '必填!'}],
        personAddressForZipCode: [{required: true, pattern: pattern.zipCode, message: '5或6位数字!'}],
        governmentScholarshipDesc: [{required: true, message: '必填!'}],
        organisationScholarshipDesc: [{required: true, message: '必填!'}],
        personalScholarCost: [{required: true, message: '必填!'}],
        personalScholarshipDesc: [{required: true, message: '必填!'}],
        otherPeopleForRelationship: [{required: true, message: '必填!'}],
        otherPeopleScholarshipCost: [{required: true, message: '必填!'}],
        otherPeopleScholarshipDesc: [{required: true, message: '必填!'}],
        otherScholarshipDesc: [{required: true, message: '必填!'}],

        hasCompanion: [{required: true, message: '必填!'}],
        companionSurname1: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionGivenName1: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionSex1: [{required: true, message: '必填!'}],
        companionBirth1: [{required: true, message: '必填!'}],
        companionRelationship1: [{required: true, message: '必填!'}],
        companionPassportNumber1: {required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'},
        companionDateOfPassport1: [{required: true, message: '必填!'}],
        companionPlaceOfPassport1: [{required: true, message: '必填!'}],
        companionTRN1: [],


        companionSurname2: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionGivenName2: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionSex2: [{required: true, message: '必填!'}],
        companionBirth2: [{required: true, message: '必填!'}],
        companionRelationship2: [{required: true, message: '必填!'}],
        companionPassportNumber2: {required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'},
        companionDateOfPassport2: [{required: true, message: '必填!'}],
        companionPlaceOfPassport2: [{required: true, message: '必填!'}],
        companionTRN2: [],

        companionSurname3: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionGivenName3: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionSex3: [{required: true, message: '必填!'}],
        companionBirth3: [{required: true, message: '必填!'}],
        companionRelationship3: [{required: true, message: '必填!'}],
        companionPassportNumber3: {required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'},
        companionDateOfPassport3: [{required: true, message: '必填!'}],
        companionPlaceOfPassport3: [{required: true, message: '必填!'}],
        companionTRN3: [],

        companionSurname4: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionGivenName4: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionSex4: [{required: true, message: '必填!'}],
        companionBirth4: [{required: true, message: '必填!'}],
        companionRelationship4: [{required: true, message: '必填!'}],
        companionPassportNumber4: {required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'},
        companionDateOfPassport4: [{required: true, message: '必填!'}],
        companionPlaceOfPassport4: [{required: true, message: '必填!'}],
        companionTRN4: [],

        companionSurname5: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionGivenName5: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionSex5: [{required: true, message: '必填!'}],
        companionBirth5: [{required: true, message: '必填!'}],
        companionRelationship5: [{required: true, message: '必填!'}],
        companionPassportNumber5: {required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'},
        companionDateOfPassport5: [{required: true, message: '必填!'}],
        companionPlaceOfPassport5: [{required: true, message: '必填!'}],
        companionTRN5: [],

        companionSurname6: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionGivenName6: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companionSex6: [{required: true, message: '必填!'}],
        companionBirth6: [{required: true, message: '必填!'}],
        companionRelationship6: [{required: true, message: '必填!'}],
        companionPassportNumber6: {required: true, pattern: pattern.passportNumber, message: '输入有误,A-Z或0-9'},
        companionDateOfPassport6: [{required: true, message: '必填!'}],
        companionPlaceOfPassport6: [{required: true, message: '必填!'}],
        companionTRN6: [],

        familySurname1: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familyGivenName1: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familySex1: [{required: true, message: '必填!'}],
        familyBirth1: [{required: true, message: '必填!'}],
        familyRelationship1: [{required: true, message: '必填!'}],
        familyNationalIdentification1: [{
          required: true,
          pattern: pattern.nationalIdentification,
          message: '必填,身份证格式!'
        }],
        familyDateOfIdentification1: [{required: true, message: '必填!'}],
        familyProvinceOfBirth1: [{required: true, message: '必填!'}],
        familyCityOfBirth1: [{required: true, message: '必填!'}],

        familySurname2: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familyGivenName2: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familySex2: [{required: true, message: '必填!'}],
        familyBirth2: [{required: true, message: '必填!'}],
        familyRelationship2: [{required: true, message: '必填!'}],
        familyNationalIdentification2: [{
          required: true,
          pattern: pattern.nationalIdentification,
          message: '必填,身份证格式!'
        }],
        familyDateOfIdentification2: [{required: true, message: '必填!'}],
        familyProvinceOfBirth2: [{required: true, message: '必填!'}],
        familyCityOfBirth2: [{required: true, message: '必填!'}],

        familySurname3: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familyGivenName3: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familySex3: [{required: true, message: '必填!'}],
        familyBirth3: [{required: true, message: '必填!'}],
        familyRelationship3: [{required: true, message: '必填!'}],
        familyNationalIdentification3: [{
          required: true,
          pattern: pattern.nationalIdentification,
          message: '必填,身份证格式!'
        }],
        familyDateOfIdentification3: [{required: true, message: '必填!'}],
        familyProvinceOfBirth3: [{required: true, message: '必填!'}],
        familyCityOfBirth3: [{required: true, message: '必填!'}],

        familySurname4: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familyGivenName4: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familySex4: [{required: true, message: '必填!'}],
        familyBirth4: [{required: true, message: '必填!'}],
        familyRelationship4: [{required: true, message: '必填!'}],
        familyNationalIdentification4: [{
          required: true,
          pattern: pattern.nationalIdentification,
          message: '必填,身份证格式!'
        }],
        familyDateOfIdentification4: [{required: true, message: '必填!'}],
        familyProvinceOfBirth4: [{required: true, message: '必填!'}],
        familyCityOfBirth4: [{required: true, message: '必填!'}],

        familySurname5: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familyGivenName5: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        familySex5: [{required: true, message: '必填!'}],
        familyBirth5: [{required: true, message: '必填!'}],
        familyRelationship5: [{required: true, message: '必填!'}],
        familyNationalIdentification5: [{
          required: true,
          pattern: pattern.nationalIdentification,
          message: '必填,身份证格式!'
        }],
        familyDateOfIdentification5: [{required: true, message: '必填!'}],
        familyProvinceOfBirth5: [{required: true, message: '必填!'}],
        familyCityOfBirth5: [{required: true, message: '必填!'}],


        workType: [{required: true, message: '必填!'}],
        occupationGroup: [{required: true, message: '必填!'}],
        occupationDetail: [{required: true, message: '必填!'}],
        companyName: [{required: true, message: '必填!'}],
        startWorkDate: [{required: true, message: '必填!'}],
        companyAddressForProvince: [{required: true, message: '必填!'}],
        companyAddressForCity: [{required: true, message: '必填!'}],
        companyAddressForStreet: [{required: true, message: '必填!'}],
        companyAddressForZipCode: [{pattern: pattern.zipCode, message: '5或6位数字!'}],
        companyContactFamilyName: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companyContactGivenName: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        companyContactPosition: [{required: true, message: '必填!'}],
        companyContactPhone: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        companyPhoneNumber: [{pattern: pattern.number, message: '请输入数字!'}],
        companyEmail: [{pattern: pattern.mail, message: '输入有误,请检查!'}],
        unemployedDate: [{required: true, message: '必填!'}],
        unemployedPosition: [{required: true, message: '必填!'}],
        retiredDate: [{required: true, message: '必填!'}],
        institutionName: [{required: true, message: '必填!'}],
        courseName: [{required: true, message: '必填!'}],
        dateOfStudy: [{required: true, message: '必填!'}],
        otherForWork: [{required: true, message: '必填!'}],

        highestOfSchool: [{required: true, message: '必填!'}],
        highestOfInstitutionName: [{required: true, message: '必填!'}],
        highestOfCourseName: [{required: true, message: '必填!'}],
        highestOfStudyDate: [{required: true, message: '必填!'}],

        visaPurpose: [{required: true, message: '必填!'}],
        hasActivity: [{required: true, message: '必填!'}],
        tripDetail: [
          { required: true, message: '必填!' },
          { max: 80, message: '长度不超过 80 个中文字符', trigger: 'blur' },
        ],
        frequentType: [{required: true, message: '必填!'}],
        vln: [{required: true, message: '必填!'}],
        activity: [{required: true, message: '必填!'}],
        location: [{required: true, message: '必填!'}],
        dateOfActivity: [{required: true, message: '必填!'}],
        organisationName: [{required: true, message: '必填!'}],
        aAddressForProvince: [{required: true, message: '必填!'}],
        aAddressForCity: [{required: true, message: '必填!'}],
        aAddressForStreet: [{required: true, message: '必填!'}],
        aAddressForZipCode: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        contactFamilyName: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        contactGivenName: [{required: true, pattern: pattern.english, message: '必填,英文格式!'}],
        contactPosition: [{required: true, message: '必填!'}],
        contactPhone: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        contactEmail: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        hasVisitRelatives: [{required: true, message: '必填!'}],
        relativeSurnames1: [{required: true, message: '必填!'}],
        relativeGivenNames1: [{required: true, message: '必填!'}],
        relativeSex1: [{required: true, message: '必填!'}],
        relativeBirth1: [{required: true, message: '必填!'}],
        relativeResidency1: [{required: true, message: '必填!'}],
        relativeState1: [{required: true, message: '必填!'}],
        relativeCity1: [{required: true, message: '必填!'}],
        relativeStreet1: [{required: true, message: '必填!'}],
        relativeZipCode1: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        relativePhone1: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        relativeEmail1: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        relationship1: [{required: true, message: '必填!'}],
        relativeSurnames2: [{required: true, message: '必填!'}],
        relativeGivenNames2: [{required: true, message: '必填!'}],
        relativeSex2: [{required: true, message: '必填!'}],
        relativeBirth2: [{required: true, message: '必填!'}],
        relativeResidency2: [{required: true, message: '必填!'}],
        relativeState2: [{required: true, message: '必填!'}],
        relativeCity2: [{required: true, message: '必填!'}],
        relativeStreet2: [{required: true, message: '必填!'}],
        relativeZipCode2: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        relativePhone2: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        relativeEmail2: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        relationship2: [{required: true, message: '必填!'}],
        relativeSurnames3: [{required: true, message: '必填!'}],
        relativeGivenNames3: [{required: true, message: '必填!'}],
        relativeSex3: [{required: true, message: '必填!'}],
        relativeBirth3: [{required: true, message: '必填!'}],
        relativeResidency3: [{required: true, message: '必填!'}],
        relativeState3: [{required: true, message: '必填!'}],
        relativeCity3: [{required: true, message: '必填!'}],
        relativeStreet3: [{required: true, message: '必填!'}],
        relativeZipCode3: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        relativePhone3: [{required: true, pattern: pattern.number, message: '请输入数字!'}],
        relativeEmail3: [{required: true, pattern: pattern.mail, message: '输入有误,请检查!'}],
        relationship3: [{required: true, message: '必填!'}],
        hasFirstStudent: [{required: true, message: '必填!'}],
        coeNumber: [{pattern: pattern.coe, message: '请输入7-10位数字与字母!'}],
        educationSector: [{required: true, message: '必填!'}],
        evidenceType: [{required: true, message: '必填!'}],
        courseCode: [{required: true, message: '必填!'}],
        courseTitle: [{required: true, message: '必填!'}],
        educationCode: [{required: true, message: '必填!'}],
        educationTitle: [{required: true, message: '必填!'}],
        dateOfCourse: [{required: true, message: '必填!'}],
        economicDesc: [{required: true, message: '必填!'}],
        studyReasonDesc: [{required: true, message: '必填!'}],
        studyCompleteDesc: [{required: true, message: '必填!'}],
        otherStudyDesc: [{required: true, message: '必填!'}],
        studyHistoryDesc: [{required: true, message: '必填!'}],

        hasVisa: [{required: true, message: '必填'}],
        hasTravelled: [{required: true, message: '必填'}],
        grantNumber: [{pattern: pattern.number, message: '请输入数字!'}],
        commercialCode: [],
        otherVisa: [],
        otherRefuse: [],

        identityImgUrl: [{required: true, message: '请上传图片文件'}],
        passportImgUrl: [{required: true, message: '请上传图片文件'}],
        familyImgUrl1: [{required: true, message: '请上传图片文件'}],
        familyImgUrl2: [{required: true, message: '请上传图片文件'}],
        familyImgUrl3: [{required: true, message: '请上传图片文件'}],
      },
      url: {
        complement: window._CONFIG['domainURL'] + "/ausDs/complement",
        upload: window._CONFIG['domainURL'] + "/power/uploadFile",
        draftSave: window._CONFIG['domainURL'] + "/power/ausDs/draftSave",
        securityCode: window._CONFIG['domainURL'] + "/ausDs/securityCode",
      }
    }
  },
  methods: {

    addRelativeRecord(i) {
      this.$set(this.form, ['relativeRecord' + i], 'Yes');
    },
    removeRelativeRecord(i) {
      this.$set(this.form, ['relativeRecord' + i], 'No');
    },
    addCompanionRecord(i) {
      this.$set(this.form, ['companionRecord' + i], 'Yes');
    },
    removeCompanionRecord(i) {
      this.$set(this.form, ['companionRecord' + i], 'No');
    },
    addFamilyRecord(i) {
      this.$set(this.form, ['familyRecord' + i], 'Yes');
    },
    removeFamilyRecord(i) {
      this.$set(this.form, ['familyRecord' + i], 'No');
    },
    beforeBirthday(current) {
      if (this.model.birthday) {
        return current < moment(this.model.birthday, 'YYYY-MM-DD');
      }
    },
    beforeNow(current) {
      return current && current < moment().startOf('day');
    },
    afterNow(current) {
      return current && current > moment().startOf('day');
    },
    beforeDateOfIntend(current) {
      if (this.form.startDateOfIntend) {
        return current < moment(this.form.startDateOfIntend, 'YYYY-MM-DD');
      }
    },

    handleChange(info, data) {
      if (info.file.status === 'uploading') {
        data.loading = true;
        this.$set(this.form, [data.name], '');
      }
      if (info.file.status === 'done') {
        data.loading = false;
        let response = info.file.response;
        if (response.code === 200) {
          this.$set(this.form, [data.name], response.data.url);
        }
      }
      if (info.file.status === 'error') {
        data.loading = false;
      }
    },

    handleDraft() {
      const that = this;
      that.model.content = JSON.stringify(that.form);
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.$emit('completeDraft');
          } else {
            that.$message.error(response.msg);
          }
        }
      }
      that.$axios.put(that.url.draftSave, that.model, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    },

    init(data) {
      this.$refs.targetForm.clearValidate();
      this.model = Object.assign({}, data);
      this.form = {};
      if (this.model.content) {
        this.form = JSON.parse(this.model.content);
      }
    },
    handleValid() {
      this.$refs.targetForm.validate((valid) => {
        if (valid) {
          this.$message.success("验证通过")
          return;
        }
        this.$message.warning("验证不通过")
      })
    },
    vailBeforeSubmit(that) {
      if (moment(that.form.startDateOfIntend, 'YYYY-MM-DD') < moment()) {
        that.$message.warning("抵达澳洲日期不能早于今天");
        return false
      }

      let dateOfCourse = that.form.dateOfCourse
      if (dateOfCourse && moment(dateOfCourse[0], 'YYYY-MM-DD') < moment()) {
        that.$message.warning("课程时间不能早于今天");
        return false
      }

      return true;
    },
    handleSubmit() {
      const that = this;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            // that.applyVisible = true;
            // that.applySpinVisible = true;
          } else {
            that.$message.error(response.msg);
            that.applyVisible = false;
            that.applySpinVisible = false;
          }
        }
      }
      this.$refs.targetForm.validate((valid) => {
        if (valid && that.vailBeforeSubmit(that)) {
          that.$message.warning("验证通过")
          that.$emit('before');
          that.applyVisible = true;
          that.applySpinVisible = true;
          that.model.content = JSON.stringify(that.form);
          that.$axios.put(that.url.complement, that.model, {headers: that.headers})
              .then(handleSuccess)
              .catch((error) => that.catchError(error).then(handleSuccess))
              .finally(() => that.$emit('finally'));
        } else {
          that.$message.warning("验证不通过")
        }
      })
    },

    setSecurityCode() {
      const that = this;
      let data = {id: that.model.id, securityCode: that.form.securityCode}
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.form.securityCode = null;
            that.applySpinVisible = true;
            that.applyInputVisible = false;
          }
        }
      }
      that.$axios.put(that.url.securityCode, data, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess));
    },

    onSocketMessage(e) {
      const data = JSON.parse(e.data);
      if ("error" === data.status && "fail" === data.message) {
        this.applyVisible = false;
        this.applySpinVisible = false;
        this.applyInputVisible = false;
        this.$emit('fail');
        return
      }
      if ("success" === data.status && "start" === data.message) {
        this.applySpinVisible = false;
        this.applyInputVisible = true;
        return
      }
      if ("success" === data.status && "complete" === data.message) {
        this.applyVisible = false;
        this.applySpinVisible = false;
        this.applyInputVisible = false;
        this.$emit('complete');
        return
      }
    },


  },
  mounted() {
    this.initWebSocket("ausDsApply");
  }

}
</script>

<style scoped>

.dynamic-add-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #87d068;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-add-button:hover {
  color: #26cc2a;
}

.dynamic-add-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
  margin-left: 20px;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

</style>
